<template>
  <section class="customer-list">
    <aside class="customer-status">
      <div @click="onClickTabStatus('CHURNED')" class="status-button" :class="tabStatusActive == 'CHURNED' ? 'active' : ''">
        <div class="status-button-text">
          Churned
          <div class="tooltip-question">
            <CommentBox class="title-question-icon" />
            <span class="tooltip-text">
              <div class="title">{{ 'Churned' }}</div>
            </span>
          </div>
        </div>
        <div class="status-button-count">5</div>
        <div class="status-button-select" />
      </div>
      <div @click="onClickTabStatus('RISK_CHURNED')" class="status-button" :class="tabStatusActive == 'RISK_CHURNED' ? 'active' : ''">
        <div class="status-button-text">
          Risk Churn
          <div class="tooltip-question">
            <CommentBox class="title-question-icon" />
            <span class="tooltip-text">
              <div class="title">{{ 'Risk Churn' }}</div>
            </span>
          </div>
        </div>
        <div class="status-button-count">4</div>
        <div class="status-button-select" />
      </div>
      <div @click="onClickTabStatus('NORMAL')" class="status-button" :class="tabStatusActive == 'NORMAL' ? 'active' : ''">
        <div class="status-button-text">
          Normal
          <div class="tooltip-question">
            <CommentBox class="title-question-icon" />
            <span class="tooltip-text">
              <div class="title">{{ 'Normal' }}</div>
            </span>
          </div>
        </div>
        <div class="status-button-count">70</div>
        <div class="status-button-select" />
      </div>

      <div class="divider"></div>

      <div @click="onClickTabStatus('WIN_BACK')" class="status-button" :class="tabStatusActive == 'WIN_BACK' ? 'active' : ''">
        <div class="status-button-text">
          Win-Back
          <div class="tooltip-question">
            <CommentBox class="title-question-icon" />
            <span class="tooltip-text">
              <div class="title">{{ 'Win-Back' }}</div>
            </span>
          </div>
        </div>
        <div class="status-button-count">3</div>
        <div class="status-button-select" />
      </div>
    </aside>

    <div class="customer-table-container">
      <div v-if="tabStatusActive != 'WIN_BACK'" class="customer-table">
        <base-table
          :checkbox="true"
          :columns="fields"
          :data="customers"
          :current-page="pagination.currentPage"
          :per-pages="pagination.perPage"
          responsive
          hover
        >
          <!-- <template #cell(segmentName)="data">
            <div class="segment-name font-f2">{{ data.item.segmentName }}</div>
          </template> -->
          <!-- <template #cell(folder)="data">
            <div class="folder">{{ data.item.folder || '-' }}</div>
          </template> -->
          <!-- <template #cell(campaign_count)="data">
            <div class="campaign">{{ data.item.campaign_count || 0 }}</div>
          </template> -->
          <!-- <template #cell(lastUpdate)="data">
            <div>{{ convertDateTable(data.item.lastUpdate) || '-' }}</div>
          </template> -->
          <template #busy>
            <loader-spinner />
          </template>
        </base-table>
      </div>
      <div v-else class="customer-table">
        <select-expand-table
          class="base-table"
          :data="dataTable"
          :columns="columnTableExpand"
          hover
          responsive
          :data-expand="dataTableExpand"
          :columns-expand="columnExpand"
          :expandOneOnly="false"
          :key="keyTableExpand"
          show-columns-expand
          :expand="true"
          :expand-end-column="false"
          :checkbox="true"
        >
          <!-- Expand -->
          <!-- <template #cellExpand(channel)="data">
            {{ convertChannelName(data.item.channel) }}
          </template> -->
        </select-expand-table>
      </div>
      <div class="d-flex justify-content-between py-3">
        <div class="d-flex justify-content-center align-items-center ps-5" style="height: fit-content">
          {{ t('communication.show') }}
          <v-select
            class="px-2"
            :modelValue="pagination.perPage"
            @update:modelValue="setPagination"
            :options="dropDownPagination"
            :clearable="false"
            :searchable="false"
          >
          </v-select>
          {{ t('communication.list') }}
        </div>

        <pagination
          class="pe-5"
          style="padding-top: 0.313rem"
          :key="pagination.perPage"
          v-model="pagination.currentPage"
          :totalRows="pagination.totalRows"
          :perPages="pagination.perPage"
        />
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw, reactive, watch } from 'vue';
import CommentBox from '@/assets/icons/modules/segment/all-segment/CommentBox.vue';
import useConvertDate from '@/utils/hooks/useConvertDate';
import { useI18n } from 'vue-i18n';

import BaseTable from '@/views/components/table/base-table/BaseTable.vue';
import SelectExpandTable from '@/views/components/table/select-expand-table/SelectExpandTable.vue';

import Pagination from '@/views/components/pagination/Pagination.vue';
import LoaderSpinner from '@/views/components/loader/loader-spinner.vue';
const { t } = useI18n();

const { convertDate } = useConvertDate();
const tabStatusActive: Ref<string> = ref('CHURNED');
const pagination: BaseTable.Pagination = reactive({
  currentPage: 1,
  perPage: 10,
  totalRows: 0,
});
const fields: Ref<BaseTable.TableColumn[]> = ref([
  { key: 'cid', label: 'CID' },
  { key: 'merge_cid', label: 'Merge_CID' },
  { key: 'sourceid', label: 'SourceID' },
  { key: 'customerid', label: 'CustomerID' },
  { key: 'customername', label: 'CustomerName' },
  { key: 'tiername', label: 'TierName' },
  { key: 'last_visit', label: 'Last Visit' },
  { key: 'actual_churn_value', label: 'Actual Churn Value' },
  { key: 'avg_churn_value', label: 'Avg. Churn Value' },
  { key: 'cl', label: 'CL' },
  { key: 'churned_dt', label: 'Churned_DT' },
]);
const dataTable: Ref<any[]> = ref([]);
const isSelectAll: Ref<boolean> = ref(false);
const dataTableExpand: Ref<any[]> = ref([]);
const columnTableExpand = ref<Array<SelectExpandTable.TableColumn>>([]);
const columnExpand = ref<Array<SelectExpandTable.TableColumn>>([]);
const keyTableExpand: Ref<number> = ref(0);
const dropDownPagination = ref([5, 10, 15, 20]);
const customers = ref<any[]>([]);
const selectData: Ref<any[]> = ref([]);
// 1. SelectAll (none) 2. SelectAll but Except (all) 3. ExcludeAll but Except (custom)
const selectMode: Ref<number> = ref(3);

function countSelect() {
  // const total: Ref<number> = ref(0);
  // if (selectMode.value == 2 && selectData.value.length > 0) {
  //   total.value = pagination.totalRows - selectData.value.length;
  // } else if (selectMode.value == 2 && selectData.value.length == 0) {
  //   total.value = pagination.totalRows;
  // } else if (selectMode.value == 3) {
  //   total.value = selectData.value.length;
  // }
  // const dataSelect: Ref<Resume.DataList[]> = ref([]);
  // if (selectMode.value == 2 && selectData.value.length > 0) {
  //   dataSelect.value = dataTable.value.filter((data) => !selectData.value.some((select) => select.id === data.id));
  // } else if (selectMode.value == 2 && selectData.value.length == 0 && dataTable.value.length == 1) {
  //   dataSelect.value = dataTable.value;
  // } else {
  //   dataSelect.value = selectData.value;
  // }
  // const data: Resume.DataDetailSelect = {
  //   select_mode: selectMode.value,
  //   search: [{ Seq: 1, Key: 'Query', Value: tableDataSearch.value }],
  //   data_selectMode: selectData.value,
  //   data_select: dataSelect.value,
  //   total_count: total.value,
  //   module: Module.Mka,
  //   list_channel: [],
  // };
  // if (isSelectAll.value) {
  //   emit('count-select', 'all');
  //   emit('detail-select', data);
  // } else {
  //   emit('count-select', total.value !== 0 ? ` ${total.value} ` : '');
  //   emit('detail-select', data);
  // }
}

function resetSelect() {
  isSelectAll.value = false;
  selectMode.value = 3;
  selectData.value = [];
}

function getData() {
  const MockData = [
    {
      cid: 'C001',
      merge_cid: 'M001',
      sourceid: 'S001',
      customerid: 'CU001',
      customername: 'John Doe',
      tiername: 'Gold',
      last_visit: '2024-07-24',
      actual_churn_value: 5000,
      avg_churn_value: 4500,
      cl: 90,
      churned_dt: '2024-07-31',
      actual_risk_churn_value: 4800,
      avg_risk_churn_value: 4700,
      total_spending: 10000,
      avg_spending: 1200,
      actual_win_back_value: 5500,
      avg_win_back_value: 5300,
      win_back: true,
      visit_total_after_comeback: 3,
      no: 1,
      date: '2024-08-01',
      time: '14:30',
      visit_after_comeback: 1,
    },
    {
      cid: 'C002',
      merge_cid: 'M002',
      sourceid: 'S002',
      customerid: 'CU002',
      customername: 'Jane Smith',
      tiername: 'Platinum',
      last_visit: '2024-08-10',
      actual_churn_value: 3000,
      avg_churn_value: 3200,
      cl: 85,
      churned_dt: '2024-08-15',
      actual_risk_churn_value: 3100,
      avg_risk_churn_value: 3300,
      total_spending: 15000,
      avg_spending: 1100,
      actual_win_back_value: 5000,
      avg_win_back_value: 5200,
      win_back: true,
      visit_total_after_comeback: 4,
      no: 2,
      date: '2024-08-20',
      time: '16:45',
      visit_after_comeback: 2,
    },
    {
      cid: 'C003',
      merge_cid: 'M003',
      sourceid: 'S003',
      customerid: 'CU003',
      customername: 'Michael Johnson',
      tiername: 'Silver',
      last_visit: '2024-07-30',
      actual_churn_value: 4000,
      avg_churn_value: 4200,
      cl: 88,
      churned_dt: '2024-08-05',
      actual_risk_churn_value: 3900,
      avg_risk_churn_value: 4000,
      total_spending: 9000,
      avg_spending: 1300,
      actual_win_back_value: 4800,
      avg_win_back_value: 4900,
      win_back: false,
      visit_total_after_comeback: 2,
      no: 3,
      date: '2024-08-25',
      time: '15:10',
      visit_after_comeback: 0,
    },
    {
      cid: 'C004',
      merge_cid: 'M004',
      sourceid: 'S004',
      customerid: 'CU004',
      customername: 'Emily Davis',
      tiername: 'Gold',
      last_visit: '2024-07-12',
      actual_churn_value: 4500,
      avg_churn_value: 4300,
      cl: 87,
      churned_dt: '2024-07-20',
      actual_risk_churn_value: 4400,
      avg_risk_churn_value: 4600,
      total_spending: 14000,
      avg_spending: 1000,
      actual_win_back_value: 5200,
      avg_win_back_value: 5100,
      win_back: true,
      visit_total_after_comeback: 5,
      no: 4,
      date: '2024-08-30',
      time: '13:00',
      visit_after_comeback: 3,
    },
    {
      cid: 'C005',
      merge_cid: 'M005',
      sourceid: 'S005',
      customerid: 'CU005',
      customername: 'David Wilson',
      tiername: 'Platinum',
      last_visit: '2024-07-01',
      actual_churn_value: 6000,
      avg_churn_value: 5800,
      cl: 92,
      churned_dt: '2024-07-10',
      actual_risk_churn_value: 5900,
      avg_risk_churn_value: 6000,
      total_spending: 16000,
      avg_spending: 1400,
      actual_win_back_value: 5700,
      avg_win_back_value: 5800,
      win_back: false,
      visit_total_after_comeback: 0,
      no: 5,
      date: '2024-09-05',
      time: '11:45',
      visit_after_comeback: 0,
    },
    {
      cid: 'C006',
      merge_cid: 'M006',
      sourceid: 'S006',
      customerid: 'CU006',
      customername: 'Olivia Brown',
      tiername: 'Silver',
      last_visit: '2024-07-08',
      actual_churn_value: 3500,
      avg_churn_value: 3400,
      cl: 84,
      churned_dt: '2024-07-18',
      actual_risk_churn_value: 3600,
      avg_risk_churn_value: 3500,
      total_spending: 12000,
      avg_spending: 900,
      actual_win_back_value: 4900,
      avg_win_back_value: 4700,
      win_back: true,
      visit_total_after_comeback: 6,
      no: 6,
      date: '2024-09-10',
      time: '09:30',
      visit_after_comeback: 4,
    },
    {
      cid: 'C007',
      merge_cid: 'M007',
      sourceid: 'S007',
      customerid: 'CU007',
      customername: 'Lucas Moore',
      tiername: 'Gold',
      last_visit: '2024-07-27',
      actual_churn_value: 3800,
      avg_churn_value: 4000,
      cl: 89,
      churned_dt: '2024-08-02',
      actual_risk_churn_value: 3700,
      avg_risk_churn_value: 3800,
      total_spending: 10500,
      avg_spending: 1250,
      actual_win_back_value: 4600,
      avg_win_back_value: 4500,
      win_back: false,
      visit_total_after_comeback: 1,
      no: 7,
      date: '2024-09-12',
      time: '10:45',
      visit_after_comeback: 0,
    },
    {
      cid: 'C008',
      merge_cid: 'M008',
      sourceid: 'S008',
      customerid: 'CU008',
      customername: 'Sophia Lee',
      tiername: 'Platinum',
      last_visit: '2024-08-05',
      actual_churn_value: 4900,
      avg_churn_value: 4700,
      cl: 91,
      churned_dt: '2024-08-12',
      actual_risk_churn_value: 4500,
      avg_risk_churn_value: 4600,
      total_spending: 17000,
      avg_spending: 1600,
      actual_win_back_value: 5800,
      avg_win_back_value: 5900,
      win_back: true,
      visit_total_after_comeback: 7,
      no: 8,
      date: '2024-09-15',
      time: '12:15',
      visit_after_comeback: 5,
    },
    {
      cid: 'C009',
      merge_cid: 'M009',
      sourceid: 'S009',
      customerid: 'CU009',
      customername: 'Isabella Martinez',
      tiername: 'Gold',
      last_visit: '2024-08-02',
      actual_churn_value: 3200,
      avg_churn_value: 3000,
      cl: 83,
      churned_dt: '2024-08-08',
      actual_risk_churn_value: 3300,
      avg_risk_churn_value: 3400,
      total_spending: 9000,
      avg_spending: 1100,
      actual_win_back_value: 5300,
      avg_win_back_value: 5200,
      win_back: false,
      visit_total_after_comeback: 2,
      no: 9,
      date: '2024-09-17',
      time: '14:00',
      visit_after_comeback: 1,
    },
    {
      cid: 'C010',
      merge_cid: 'M010',
      sourceid: 'S010',
      customerid: 'CU010',
      customername: 'James Clark',
      tiername: 'Silver',
      last_visit: '2024-07-29',
      actual_churn_value: 4100,
      avg_churn_value: 4300,
      cl: 86,
      churned_dt: '2024-08-04',
      actual_risk_churn_value: 4000,
      avg_risk_churn_value: 3900,
      total_spending: 9500,
      avg_spending: 1200,
      actual_win_back_value: 4700,
      avg_win_back_value: 4800,
      win_back: true,
      visit_total_after_comeback: 3,
      no: 10,
      date: '2024-09-20',
      time: '11:00',
      visit_after_comeback: 2,
    },
  ];
  customers.value = MockData;
  pagination.totalRows = MockData.length;
  dataTableExpand.value = [
    {
      id: '001',
      no: 1,
      date: '2024-10-01',
      time: '10:00',
      visit_after_comeback: 3,
      parent_id: '001',
    },
    {
      id: '002',
      no: 2,
      date: '2024-10-02',
      time: '11:30',
      visit_after_comeback: 4,
      parent_id: '003',
    },
    {
      id: '003',
      no: 3,
      date: '2024-10-03',
      time: '09:15',
      visit_after_comeback: 5,
      parent_id: '002',
    },
    {
      id: '004',
      no: 4,
      date: '2024-10-04',
      time: '14:45',
      visit_after_comeback: 2,
      parent_id: '005',
    },
    {
      id: '005',
      no: 5,
      date: '2024-10-05',
      time: '12:30',
      visit_after_comeback: 6,
      parent_id: '001',
    },
    {
      id: '006',
      no: 6,
      date: '2024-10-06',
      time: '15:00',
      visit_after_comeback: 1,
      parent_id: '003',
    },
    {
      id: '007',
      no: 7,
      date: '2024-10-07',
      time: '16:00',
      visit_after_comeback: 3,
      parent_id: '006',
    },
    {
      id: '008',
      no: 8,
      date: '2024-10-08',
      time: '10:30',
      visit_after_comeback: 5,
      parent_id: '007',
    },
    {
      id: '009',
      no: 9,
      date: '2024-10-09',
      time: '09:45',
      visit_after_comeback: 2,
      parent_id: '004',
    },
    {
      id: '010',
      no: 10,
      date: '2024-10-10',
      time: '13:15',
      visit_after_comeback: 4,
      parent_id: '002',
    },
  ];
  dataTable.value = dataTable.value = [
    {
      id: 1,
      cid: '001',
      merge_cid: '1001',
      sourceid: 'S001',
      customerid: 'CUST001',
      customername: 'John Doe',
      tiername: 'Gold',
      last_visit: '2024-08-01',
      actual_win_back_value: 5000,
      avg_win_back_value: 4500,
      cl: 'High',
      win_back: true,
      visit_total_after_comeback: 5,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 2,
      cid: '002',
      merge_cid: '1002',
      sourceid: 'S002',
      customerid: 'CUST002',
      customername: 'Jane Smith',
      tiername: 'Silver',
      last_visit: '2024-09-10',
      actual_win_back_value: 3000,
      avg_win_back_value: 3200,
      cl: 'Medium',
      win_back: false,
      visit_total_after_comeback: 2,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 3,
      cid: '003',
      merge_cid: '1003',
      sourceid: 'S003',
      customerid: 'CUST003',
      customername: 'Robert Brown',
      tiername: 'Platinum',
      last_visit: '2024-07-15',
      actual_win_back_value: 7500,
      avg_win_back_value: 7000,
      cl: 'Very High',
      win_back: true,
      visit_total_after_comeback: 10,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 4,
      cid: '004',
      merge_cid: '1004',
      sourceid: 'S004',
      customerid: 'CUST004',
      customername: 'Emily Davis',
      tiername: 'Gold',
      last_visit: '2024-10-01',
      actual_win_back_value: 500,
      avg_win_back_value: 550,
      cl: 'Low',
      win_back: false,
      visit_total_after_comeback: 1,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 5,
      cid: '005',
      merge_cid: '1005',
      sourceid: 'S005',
      customerid: 'CUST005',
      customername: 'Chris Wilson',
      tiername: 'Bronze',
      last_visit: '2024-09-05',
      actual_win_back_value: 1000,
      avg_win_back_value: 1200,
      cl: 'Medium',
      win_back: true,
      visit_total_after_comeback: 4,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 6,
      cid: '006',
      merge_cid: '1006',
      sourceid: 'S006',
      customerid: 'CUST006',
      customername: 'Sarah Johnson',
      tiername: 'Silver',
      last_visit: '2024-09-28',
      actual_win_back_value: 2000,
      avg_win_back_value: 1900,
      cl: 'High',
      win_back: false,
      visit_total_after_comeback: 3,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 7,
      cid: '007',
      merge_cid: '1007',
      sourceid: 'S007',
      customerid: 'CUST007',
      customername: 'David Miller',
      tiername: 'Platinum',
      last_visit: '2024-08-22',
      actual_win_back_value: 6500,
      avg_win_back_value: 6400,
      cl: 'Very High',
      win_back: true,
      visit_total_after_comeback: 7,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 8,
      cid: '008',
      merge_cid: '1008',
      sourceid: 'S008',
      customerid: 'CUST008',
      customername: 'Laura Lee',
      tiername: 'Gold',
      last_visit: '2024-07-10',
      actual_win_back_value: 4000,
      avg_win_back_value: 4200,
      cl: 'Medium',
      win_back: false,
      visit_total_after_comeback: 6,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 9,
      cid: '009',
      merge_cid: '1009',
      sourceid: 'S009',
      customerid: 'CUST009',
      customername: 'Michael Scott',
      tiername: 'Silver',
      last_visit: '2024-08-25',
      actual_win_back_value: 2200,
      avg_win_back_value: 2500,
      cl: 'Low',
      win_back: true,
      visit_total_after_comeback: 3,
      select: false,
      expand: true,
      checkbox: false,
    },
    {
      id: 10,
      cid: '010',
      merge_cid: '1010',
      sourceid: 'S010',
      customerid: 'CUST010',
      customername: 'Rachel Green',
      tiername: 'Bronze',
      last_visit: '2024-09-30',
      actual_win_back_value: 800,
      avg_win_back_value: 900,
      cl: 'Medium',
      win_back: false,
      visit_total_after_comeback: 2,
      select: false,
      expand: true,
      checkbox: false,
    },
  ];
}

function resolveFields() {
  columnTableExpand.value = [];
  columnExpand.value = [];
  dataTable.value = [];
  dataTableExpand.value = [];
  fields.value = [];
  switch (tabStatusActive.value) {
    case 'CHURNED':
      fields.value = [
        { key: 'cid', label: 'CID' },
        { key: 'merge_cid', label: 'Merge_CID' },
        { key: 'sourceid', label: 'SourceID' },
        { key: 'customerid', label: 'CustomerID' },
        { key: 'customername', label: 'CustomerName' },
        { key: 'tiername', label: 'TierName' },
        { key: 'last_visit', label: 'Last Visit' },
        { key: 'actual_churn_value', label: 'Actual Churn Value' },
        { key: 'avg_churn_value', label: 'Avg. Churn Value' },
        { key: 'cl', label: 'CL' },
        { key: 'churned_dt', label: 'Churned_DT' },
      ];
      break;
    case 'RISK_CHURNED':
      fields.value = [
        { key: 'cid', label: 'CID' },
        { key: 'merge_cid', label: 'Merge_CID' },
        { key: 'sourceid', label: 'SourceID' },
        { key: 'customerid', label: 'CustomerID' },
        { key: 'customername', label: 'CustomerName' },
        { key: 'tiername', label: 'TierName' },
        { key: 'last_visit', label: 'Last Visit' },
        { key: 'actual_risk_churn_value', label: 'Actual Risk Churn Value' },
        { key: 'avg_risk_churn_value', label: ' Avg. Risk Churn Value' },
        { key: 'cl', label: 'CL' },
      ];
      break;
    case 'NORMAL':
      fields.value = [
        { key: 'cid', label: 'CID' },
        { key: 'merge_cid', label: 'Merge_CID' },
        { key: 'sourceid', label: 'SourceID' },
        { key: 'customerid', label: 'CustomerID' },
        { key: 'customername', label: 'CustomerName' },
        { key: 'tiername', label: 'TierName' },
        { key: 'last_visit', label: 'Last Visit' },
        { key: 'total_spending', label: 'Total Spending' },
        { key: 'avg_spending', label: 'Avg. Spending' },
        { key: 'cl', label: 'CL' },
      ];
      break;
    case 'WIN_BACK':
      columnTableExpand.value = [
        { key: 'cid', label: 'CID' },
        { key: 'merge_cid', label: 'Merge_CID' },
        { key: 'sourceid', label: 'SourceID' },
        { key: 'customerid', label: 'CustomerID' },
        { key: 'customername', label: 'CustomerName' },
        { key: 'tiername', label: 'TierName' },
        { key: 'last_visit', label: 'Last Visit' },
        { key: 'actual_win_back_value', label: 'Actual Win-Back Value' },
        { key: 'avg_win_back_value', label: 'Avg. Win-Back Value' },
        { key: 'cl', label: 'CL' },
        { key: 'win_back', label: 'Win-Back' },
        { key: 'visit_total_after_comeback', label: 'Visit Total After Comeback' },
      ];
      columnExpand.value = [
        { key: 'no', label: 'No.' },
        { key: 'date', label: 'Date' },
        { key: 'time', label: 'Time' },
        { key: 'visit_after_comeback', label: 'Visit After Comeback' },
      ];
      break;
    default:
      fields.value = [
        { key: 'cid', label: 'CID' },
        { key: 'merge_cid', label: 'Merge_CID' },
        { key: 'sourceid', label: 'SourceID' },
        { key: 'customerid', label: 'CustomerID' },
        { key: 'customername', label: 'CustomerName' },
        { key: 'tiername', label: 'TierName' },
        { key: 'last_visit', label: 'Last Visit' },
        { key: 'actual_churn_value', label: 'Actual Churn Value' },
        { key: 'avg_churn_value', label: 'Avg. Churn Value' },
        { key: 'cl', label: 'CL' },
        { key: 'churned_dt', label: 'Churned_DT' },
      ];
      break;
  }
  getData();
}
function convertDateTable(date: string) {
  const apiDate = new Date(date).toISOString();
  const addHours = new Date(apiDate).getTime() + 7 * 60 * 60 * 1000;
  const result = new Date(addHours).toISOString();
  return convertDate(result);
}
function setPagination(data: any) {
  pagination.currentPage = 1;
  pagination.perPage = data;
}
function onClickTabStatus(tab: string) {
  tabStatusActive.value = tab;
}

watch(
  () => tabStatusActive.value,
  () => {
    resolveFields();
  },
);

onBeforeMount(() => {
  resolveFields();
});
</script>

<style lang="scss" scoped>
.base-table {
  &:deep(.table) {
    thead {
      tr {
        th {
          background-color: #f7f7f7;
        }
      }
    }
  }
  &:deep(.select) {
    vertical-align: middle !important;
    div {
      display: flex;
      justify-content: center;
    }
    .form-check-input {
      margin-top: 0;
    }
  }
}
.divider {
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  width: 100%;
  height: 1px;
  background: #ffffff;
}
.tooltip-question {
  position: relative;
  display: inline-block;

  &:hover {
    .tooltip-text {
      visibility: visible;
    }
  }

  .tooltip-text {
    position: relative;
    visibility: hidden;
    background-color: #efefef;
    text-align: center;
    border-radius: 6px;
    padding: 1rem;
    max-width: 370px;
    width: max-content;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: -5px;
    left: 40px;
    font-weight: 400;
    text-align: left;
    .title {
      color: #000000;
    }
    .detail {
      color: #707070;
    }

    &::after {
      content: '';
      position: absolute;
      left: -9px;
      top: 10px;
      width: 0px;
      height: 0px;

      border-right: 10px solid #efefef;
      border-bottom: 5px solid transparent;
      border-top: 5px solid transparent;
    }
  }
}
.customer-list {
  display: flex;
  width: 100%;
  .customer-status {
    display: flex;
    width: 20%;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    border-radius: 8px 0px 0px 8px;
    background: #eeeff1;
    box-shadow: -4px 0px 10px 0px rgba(0, 0, 0, 0.05) inset;
    .status-button {
      display: flex;
      justify-content: space-between;
      padding: 12px 24px;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      border-width: 0;
      border-radius: 8px;
      background: #fff;
      box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.05);
      width: 100%;
      height: 50px;
      cursor: pointer;
      .status-button-select {
        position: absolute;
        left: 85px;
        background-color: #007fff;
        border-radius: 10px 0px 0px 10px;
        height: 50px;
        width: 8px;
        opacity: 0;
      }
      &.active {
        .status-button-select {
          opacity: 1;
        }
      }
      .status-button-text {
        color: var(--Gray-04, #2d2d2d);
        font-family: Prompt;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .status-button-count {
        color: var(--Gray-04, #2d2d2d);
        text-align: right;
        font-family: Prompt;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .customer-table-container {
    flex-grow: 1;
    width: 80%;
    .customer-table {
      width: 100%;
      height: 30rem;
      overflow: auto;
    }
    &:deep(.vs__dropdown-toggle) {
      width: 80px;
    }
  }
}
</style>
